import React from "react";

export default function ShieldIcon({ color }: { color: string }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke={color} className="w-3 tsm-400:w-4 h-3 tsm-400:h-4">
            <circle cx="12" cy="12" r="9" />
            <path d="M9 12l2 2 4-4" />
        </svg>
    );
}

